import { request } from '@/utils/request';

/**
 * 获取商品列表
 */
export function getGoodsList(data: API.GetGoodsListParam) {
  return request({
    url: '/seller/goods/getList',
    method: 'post',
    data,
  });
}

/**
 * 批量上架
 */
export function upGoods(data: API.UpGoodsParam) {
  return request({
    url: '/v1/seller/goods/sjGoods',
    method: 'post',
    data,
  });
}

/**
 * 批量下架
 */
export function downGoods(data: API.DownGoodsParam) {
  return request({
    url: '/v1/seller/goods/xjGoods',
    method: 'post',
    data,
  });
}

/**
 * 批量删除
 */
export function deleteGoods(data: API.DeleteGoodsParam) {
  return request({
    url: '/v1/seller/goods/hideGoods',
    method: 'post',
    data,
  });
}

/**
 * 获取标签列表
 */
export function getTagList() {
  return request<API.TagItem[]>({
    url: '/v1/seller/goodsTag/getTagList',
    method: 'get',
  });
}

/**
 * 精选商品设置
 */
export function setHotGoods(data: API.SetHotParam) {
  return request({
    url: '/seller/goods/setHotGoods',
    method: 'post',
    data,
  });
}

/**
 * 获取精选商品设置说明
 */
export function getHotGoodsDesc() {
  return request<API.HotDesc>({
    url: '/seller/goods/getHotGoodsDesc',
    method: 'post',
  });
}

/**
 * 修改商品（暗款等级等）
 */
export function setGoods(data: API.SetGoodsParam) {
  return request({
    url: '/seller/goods/setGoods',
    method: 'post',
    data,
  });
}
